<template>
    <FormGroup :name="name" :label="label" :help-text="helpText" :error="error">
        <VueTagsInput
            v-model="tag"
            :tags="value"
            :autocomplete-items="autocompleteItems"
            :add-only-from-autocomplete="true"
            @tags-changed="$emit('input', $event)"
        />
    </FormGroup>
</template>

<script>
import http from '@/http'
import FormGroup from '@/vendor/forms/FormGroups/Block/FormGroup'
import VueTagsInput from '@johmun/vue-tags-input'

export default {
    components: {FormGroup,VueTagsInput},

    props: {
        'name': {},
        'label': {},
        'helpText': {'default': null},
        'value': {},
        'error': {},
        'options': {},
        'placeholder': {},
        'disabled': {'default': false}
    },

    data() {
        return {
            tag: '',
            debounce: null,
            autocompleteItems: []
        }
    },

    watch: {
        tag() {
            if (this.tag.length === 0) return

            clearTimeout(this.debounce)

            this.debounce = setTimeout(() => {
                http.get('/api/v2/tags?filter[search]=' + this.tag)
                    .then(response => {
                        this.autocompleteItems = response.data.data.map(tag => {
                            return {
                                text: tag.attributes.name,
                                style: 'background-color:' + tag.attributes.color + ';color:#ffffff'
                            }
                        })
                    })
            }, 300)
        }
    }

}
</script>
